export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0"},{"hid":"robots","name":"robots","content":"all"},{"name":"apple-mobile-web-app-title","content":"TopFarmacia"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon/favicon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image/svg+xml","href":"/favicon/favicon.svg"},{"rel":"shortcut icon","href":"/favicon/favicon.ico"},{"rel":"apple-touch-icon","href":"/favicon/apple-touch-icon.png","sizes":"180x180"},{"rel":"manifest","href":"/favicon/site.webmanifest"},{"rel":"preload","type":"font/woff2","href":"/fonts/Poppins/Poppins-Bold.woff2","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff2","href":"/fonts/Poppins/Poppins-SemiBold.woff2","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff2","href":"/fonts/Poppins/Poppins-Medium.woff2","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff2","href":"/fonts/Poppins/Poppins-Regular.woff2","as":"font","crossorigin":"anonymous"},{"type":"font/woff2","href":"/fonts/VT323/VT323-Regular.woff2","as":"font","crossorigin":"anonymous"}],"style":[],"script":[{"src":"https://cloud.wordlift.io/app/bootstrap.js","type":"text/javascript"},{"children":"\nwindow.dataLayer = window.dataLayer || [];","type":"text/javascript"},{"hid":"gtm","defer":true,"children":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                  j=d.createElement(s);j.async=true;j.src=\n                  'https://load.sgtm.topfarmacia.it/16qqmgipyj.js?'+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','d0vibn=aWQ9R1RNLVdHR05UQk4%3D&sort=asc');","type":"text/javascript"}],"noscript":[{"innerHTML":"<link rel='stylesheet' type='text/css' href='/no-script.css'>"},{"tagPosition":"bodyOpen","children":"<iframe src=\"https://load.sgtm.topfarmacia.it/ns.html?id=GTM-WGGNTBN\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"htmlAttrs":{"lang":"it-it","class":"it-it","data-culture":"it-it"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false